// Dates are plain YYYY-MM-DD strings in Japan time, so a lesson is "today" for everyone in the room.

export function todayISO(now = new Date()): string {
  return new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Tokyo' }).format(now);
}

export function addDays(iso: string, n: number): string {
  const d = new Date(`${iso}T00:00:00Z`);
  d.setUTCDate(d.getUTCDate() + n);
  return d.toISOString().slice(0, 10);
}

// Monday of the week the date falls in
export function weekStart(iso: string): string {
  const day = new Date(`${iso}T00:00:00Z`).getUTCDay();
  return addDays(iso, -((day + 6) % 7));
}

export function formatDay(iso: string, lang: 'en' | 'ja', style: 'short' | 'long' = 'short'): string {
  const d = new Date(`${iso}T00:00:00Z`);
  const opts: Intl.DateTimeFormatOptions =
    style === 'long'
      ? { weekday: 'long', month: 'long', day: 'numeric', timeZone: 'UTC' }
      : { weekday: 'short', month: 'short', day: 'numeric', timeZone: 'UTC' };
  return d.toLocaleDateString(lang === 'ja' ? 'ja-JP' : 'en-US', opts);
}

// 0 = Sunday
export function dayOfWeek(iso: string): number {
  return new Date(`${iso}T00:00:00Z`).getUTCDay();
}

export function daysBetween(from: string, to: string): number {
  return Math.round((Date.parse(`${to}T00:00:00Z`) - Date.parse(`${from}T00:00:00Z`)) / 86400000);
}

export const DOW_JA = ['日', '月', '火', '水', '木', '金', '土'];

// The date as it is written on a Japanese classroom board: 10月21日（水）
export function boardDate(iso: string): string {
  const [, m, d] = iso.split('-').map(Number);
  return `${m}月${d}日（${DOW_JA[dayOfWeek(iso)]}）`;
}

// 10/21
export function monthDay(iso: string): string {
  const [, m, d] = iso.split('-').map(Number);
  return `${m}/${d}`;
}
